<div class="lds-ellipsis">
  <div>
    <div [ngStyle]="{'background': color}"></div>
  </div>
  <div>
    <div [ngStyle]="{'background': color}"></div>
  </div>
  <div>
    <div [ngStyle]="{'background': color}"></div>
  </div>
  <div>
    <div [ngStyle]="{'background': color}"></div>
  </div>
  <div>
    <div [ngStyle]="{'background': color}"></div>
  </div>
</div>
